import moment from 'moment';
import { formatDisplayDateTime } from '../../lib/dateDisplay';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Loader from "react-loader-spinner";
import { connect, useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { AlertAction, CompanyAction, LicenseAction, ProductAction, RayCodeAction } from '../../actions';
import { isCon, isDIM, isDOA } from '../../components/common/CommonViews';
import { Loading } from '../../components/common/Loading';
import {
  ProductChangeSN,
  ProductDelete,
  ProductInfoACQ,
  ProductInfoError,
  ProductInfoWarranty,
} from '../../components/product';
import ProductChangeType from '../../components/product/ProductChangeType';
import ProductHistoryReport from '../../components/product/ProductHistoryReport';
import ProductInfoAlignment from '../../components/product/ProductInfoAlignment';
import ProductInfoAutoDiagnosis from '../../components/product/ProductInfoAutoDiagnosis';
import ProductInfoExtra from '../../components/product/ProductInfoExra';
import ProductInfoQC from '../../components/product/ProductInfoQC';
import ProductInfoSummary from '../../components/product/ProductInfoSummary';
import ServiceAdminList from '../../components/service/ServiceAdminList';
import { CTSegmentation, FaceAnalyzer, SmartDentFiveD } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';
import { history } from '../../history';
import { rtCrypt } from '../../utils/RTCrypt';
import AdminProductUpdateSite from './AdminProductUpdateSite';

const AdminProductInfo = ({ GetProduct, GetProductOld, product, isstock, orisninfo, errmessage, user, clist, raycodes, GetCompanyInfo, company }) => {

	const { sn, view } = useParams();
	const [isLoading, setIsLoading] = useState(true);
	const [tab, setTab] = useState(view || "info");
	const [codes, setCodes] = useState([]);
	const [editable, setEditable] = useState(false);
	const [getPInfoErr, setgetPInfoErr] = useState("");
	const [showReport, setShowReport] = useState(false);
	const [newTabList, setNewTabList] = useState([]);
	const [downloadFolder, setDownloadFolder] = useState("s3path");
	const [isLicense, setIsLicense] = useState(false);
	const [licenseInfo, setLicenseInfo] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [modalLoading, setModalLoading] = useState(false);
	const [managedGroupInfo, setManagedGroupInfo] = useState({});
	const [isKeyFileDownload, setIsKeyFileDownload] = useState(false);
	const [isRenewalLicense, setIsRenewalLicense] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!clist || clist.length === 0) {
			dispatch(RayCodeAction.GetAll());
			return;
		}
		setCodes(clist.filter(x => x.type === 'PRODUCTOPTION'));
	}, [clist])

	useEffect(() => {
		return () => {
			setgetPInfoErr(errmessage == "EP0009" ? "Doest not exist product" : "");
			dispatch(AlertAction.Clear());
		}
	}, [errmessage])

	useEffect(() => {
		setIsLoading(false);
	}, [getPInfoErr])

	useEffect(() => {
		setTab(view || "info")
	}, [view])

	useEffect(() => {
		if (!product.old) {
			setIsLoading(sn != product.sn)
		} else {
			setIsLoading(false)
		}

		if(product && product?.sn) {
			const getLicenseSN = async () => {
				setIsRenewalLicense(false);
				const licenseSN = await LicenseAction.GetLicenseSN(product);
				if(licenseSN && licenseSN?.expired && licenseSN._id === CTSegmentation.appId) {
					const expiredDate = moment(licenseSN.expired);
					const today = moment();
					const diffDays = expiredDate.diff(today, 'days');
					setIsRenewalLicense(diffDays < (licenseSN?.pre_renewal_period || 0));
				}

				if(licenseSN && licenseSN?.sn) {
					setIsLicense(true);
					setLicenseInfo(licenseSN);
				} else {
					setIsLicense(false);
					setLicenseInfo(null);
				}

				let productOptions = codes;
				if((!clist || clist.length === 0) && codes.length === 0) {
					const clists = await RayCodeAction.GetAllByFilter({ type: "PRODUCTOPTION" });
					if(clists?.length > 0) {
						setCodes(clists);
						productOptions = clists;
					}
				} else if(clist?.length > 0 && codes.length === 0) {
					productOptions = clist.filter(x => x.type === "PRODUCTOPTION");
					setCodes(productOptions);
				}
				const s3path = productOptions.find(x => x.code === product.codes);
				if(s3path) {
					setDownloadFolder(s3path?.s3path || "s3path");
				}
			};
			getLicenseSN();
			GetCompanyInfo(product?.companyId);
			getManagerGroupInfoByCompanyId();
		}
	}, [product]);

	// BUG-120 follow-up: 다른 페이지 (ImportShipment Apply 등) 에서 product 가 변경된 후
	//   본 페이지 재진입 시, store.product.sn 이 같다는 이유로 fetch 를 skip 하면 stale 표시.
	//   sn 을 deps 에 두고 mount 마다 (또는 URL sn 변경마다) GetProduct 를 호출하여 fresh 보장.
	// BUG-156: not-found(빈) 응답은 GET_PRODUCT 를 dispatch 하지 않아 위 [product] effect 가
	//   재실행되지 않아 isLoading 이 영구 true 로 고정된다. GetProduct(sn) 의 반환값(redux-thunk 는
	//   fetch 사이클 완료 시 resolve 되는 Promise 를 반환)을 fetch 완료 신호로 사용해 로딩을 해제한다.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		let cancelled = false;
		// BUG-156 review Minor-3: sn 만 바뀌는 내비게이션(SN History 등)에서 재fetch 동안
		// stale 한 이전 상품 정보가 그대로 노출되지 않도록 fetch 시작 시점에 스피너를 재표시한다.
		setIsLoading(true);
		Promise.resolve(GetProduct(sn)).finally(() => {
			if (!cancelled) setIsLoading(false);
		});
		return () => { cancelled = true; };
	}, [sn])

	const getLengthStr = (objArr, objArr2 = null) => {
		if (objArr2) {
			if (objArr) {
				return objArr.length + objArr2.length > 0 ? "(" + (objArr.length + objArr2.length) + ")" : "";
			}
		} else {
			if (objArr) {
				return objArr.length > 0 ? "(" + objArr.length + ")" : "";
			}
		}
		return "";
	}

	const tabList = [
		{ code: "info", title: t('common.label.information'), showall : true },
		{ code: "service", title: t("service.title") + getLengthStr(product?.services), showall : true },
		{ code: "error", title: t('common.label.errors') + getLengthStr(product.errs), showall : true },
		{ code: "warranty", title: t('warranty.title'), showall : true },
		{ code: "qc", title: "QC" + getLengthStr(product.qcs), showall : false },
		{ code: "dia", title: t('product.label.autoDiagnosis') + getLengthStr(product.autoDiagnoses), showall : false },
		{ code: "alignment", title: t('product.label.alignment') + getLengthStr(product.alignments, product.emsalignments), showall : false },
		//{ code: "acquisition", title: t('product.label.acquisition') + getLengthStr(product.acquisitions), showall : true },
		{ code: "acquisition", title: t('product.label.acquisition') + `${product?.cnt_acquisitions ? "(" + product?.cnt_acquisitions + ")" : "" }`, showall : true },
		{ code: "extra", title: t('common.label.details'), showall : true },
	]

	useEffect(() => {
		if(user?._id && user._id == "60d57a0d4f3e3a849e7a3c89" || user._id == "60d579bb2a4027020873e987") {
			tabList.push({ code: "del", title: t('common.button.delete')})
		}
		setNewTabList(tabList);
	}, [user, product])

	const createService = () => {
		history.push({
			pathname: '/Admin/AdminServiceAdd',
			state: {
				refer: 'PRODUCTERROR',
				item: {},
				extraItem: product,
			},
		});
	}

	const getOldInfo = (e) => {
		const oldsn = e.target.value;
		if (oldsn != "") {
			const oldsnobj = product.snhistories.filter(x => x.sn == oldsn)[0];
			GetProductOld(oldsn, oldsnobj);
		}
	}

	const goRealSn = () => {
		GetProduct(product.orisn);
	}

	const productReportshow = () => {
		if (showReport)
			setShowReport(false)
		else
			setShowReport(true)
	}

	const filter = (x) => {
		if (!codes || codes.length === 0) return x.showall;
		const taball = codes.find(c => c.group === product.model)?.category === 'Extra-oral Imaging';
		if(taball)
			return true;

		return x.showall;
	}

	const rct600Download = (productSN) => {
		const curDate = new Date().getTime();
		const url = `https://guard-data.rayteams.com/devices/${downloadFolder}/${productSN}/${productSN}.zip?t=${curDate}`
		fetch(url)
		.then(response => {
		  	if (response.status === 200) {
				const newWindow = window.open(url, '_blank');
				if (!newWindow) {
					dispatch(AlertAction.ErrorMsg(t('product.message.popupBlocked')));
				}
		  	} else if (response.status === 403) {
				const sUrl = `https://guard-data.rayteams.com/devices/${downloadFolder}/${productSN}.zip?t=${curDate}`
				fetch(sUrl).then(resp => {
					if (resp.status === 200) {
						const newWindow = window.open(sUrl, '_blank');
						if (!newWindow) {
							dispatch(AlertAction.ErrorMsg(t('product.message.popupBlocked')));
						}
					} else {
						dispatch(AlertAction.ErrorMsg(t('product.message.fileNotFoundOrUndownloadable')));
					}
				})
		  	}
			else {
				dispatch(AlertAction.ErrorMsg(t('product.message.fileNotFoundOrUndownloadable')));
		  	}
		})
		.catch(() => {
		  	dispatch(AlertAction.ErrorMsg(t('product.message.fileDownloadError')));
		});
	};

	const getManagerGroupInfoByCompanyId = async () => {
        let managerGroupInfo = await LicenseAction.GetManagerGroupInfoByCompanyId(product.companyId, product?.model?.includes('RAYFace') ? FaceAnalyzer.appId : SmartDentFiveD.appId);
        if(managerGroupInfo.length == 0) {
            managerGroupInfo = await LicenseAction.GetManagerGroupInfoByCompanyId(company?.parentCompanyId, product?.model?.includes('RAYFace') ? FaceAnalyzer.appId : SmartDentFiveD.appId);
        }
        setManagedGroupInfo(managerGroupInfo);
    };

	const createCTLicense = async () => {
		if(!product?.sn) return;
		if(!licenseInfo || licenseInfo?.length == 0 || isRenewalLicense) {
			setModalLoading(true);
			const pid = '4is86609-c37b-41fe-ac15-0c0fff2db0qq';
			const checkFireStoreSN = await LicenseAction.CheckFireStoreSN(product.sn);
			let updateParams = {};
			if(!checkFireStoreSN) {
				updateParams = {
					sn: product.sn,
					appId: 'App-CTSegmentation',
					lcType: "package",
					created: Date.now(),
					creator: user?._id || "",
					groupId: "tempgroup",
					ntid: "tempntid",
					mgroupid: managedGroupInfo?.sk?.split(":")[1] || "tempgroupid",
					userId: "tempuser",
					pid: pid
				}
			} else {
				updateParams = {
					sn: product.sn,
					appId: 'App-CTSegmentation',
					lcType: "package",
					created: Date.now(),
					creator: user?._id || "",
					groupId: checkFireStoreSN?.groupId || "tempgroup",
					ntid: checkFireStoreSN?.networkId || "tempntid",
					mgroupid: managedGroupInfo?.sk?.split(":")[1] || "tempgroupid",
					userId: "tempuser",
					pid: pid
				};
			}

			// CreateReluLicenseSN 은 실패를 삼키고 null 을 반환한다 — 값이 있을 때만 성공 안내.
			const reluRet = await LicenseAction.CreateReluLicenseSN(updateParams, product);
			if (reluRet) dispatch(AlertAction.Success(t('common.message.success.saved')));

			setIsLicense(true);
			setModalLoading(false);
			setShowModal(false);
		}
	}

	const btnKeyFileDownload = async () => {
		if (!product?.sn) return;
		setIsKeyFileDownload(true);
		setShowModal(true);
	}

	const getKeyFileDownload = async () => {
		if (!product?.sn) return;
		let licInfo = licenseInfo;
		if (!licInfo) {
			licInfo = await LicenseAction.GetLicenseSN({sn: product.sn});
		}

		try {
			// if (licInfo._id === CTSegmentation.appId) {
			// 	licInfo.ReluParams = rtCrypt.reluUrl;
			// }
			const licenseText = JSON.stringify(licInfo, null, 2);
			const encryptedText = await rtCrypt.encrypt(licenseText, { initialBase64Key: rtCrypt.stringToKey(product.sn) });
			const blob = new Blob([encryptedText], { type: 'text/plain' });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = `license_${licInfo._id}_${product.sn}.rtlc`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error("🚀 ~ getKeyFileDownload ~ error:", error)
		}

		setShowModal(false);
		setIsKeyFileDownload(false);
	};

	// BUG-156: not-found(EP0009 아닌 일반) — loading 완료 후 product 가 요청 sn 과 불일치하면
	// 빈 화면 대신 명시적 안내(기존 알림 블록 재사용). AdminServiceInfo NoRecord 와 대칭.
	const notFound = !isLoading && !getPInfoErr && (!product || product.sn != sn);

	return (
		<>
			{(getPInfoErr || notFound) && <div className="extraHeader">
				<div className="alert alert-danger ms-1 me-2">{getPInfoErr || 'Does not exist product'}</div>
				<Link to={!isstock ? "/Admin/AdminProductList" : "/Admin/AdminProductStockList"}
					className="btn btn-outline-primary mt-0 me-1">{t('common.label.list')}</Link>
			</div>}
			{(!isLoading && !getPInfoErr && !notFound) &&
				<>
					<div className="extraHeader">
						<h2 className="mb-0">
							{!product.orisn && isCon(product, 20)}
							{product.sn}
							{isDOA(product)} {isDIM(product)}
							<span className="fs-13 text-danger ms-1">{product.model}</span>
							{(product.orisn) &&
								<span className="fs-13 alert alert-success ms-1">SN Changed - {orisninfo.reason} / {formatDisplayDateTime(orisninfo.updated)} / {orisninfo.user}</span>
							}
							{product?.prdtype && <span className="btn btn-success btn-sm mt-0 ms-1">{product?.prdtype.toUpperCase()}</span>}
							{isLicense && <span className="btn btn-primary btn-sm mt-0 ms-1">{product?.model?.includes('RAYFace') ? FaceAnalyzer.name : CTSegmentation.name}</span>}
							{(!isLicense || isRenewalLicense) && user?.isCreateLicense && product?.prdtype == "5d" && <span className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => setShowModal(true)} style={{cursor: 'pointer'}}>
								{isRenewalLicense ? 'Renewal CT License' : 'Create CT License'}
							</span>}
							{isLicense && user?.isLicenseDownload && <span className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => btnKeyFileDownload()} style={{cursor: 'pointer'}}>Key File Download</span>}
							{(user.adminType == "S" || user.adminType == "M") && ((!product.orisn && tab == "info") &&
							<button onClick={() => setEditable(!editable)} className="btn btn-secondary btn-sm mt-0 ms-1">
								<ion-icon name={editable ? "lock-open-outline" : "lock-closed-outline"} />
								{editable ? t('common.status.unlocked') : t('common.status.locked')}
							</button>
							)}
						</h2>
						<div className="ray-right">
							{product?.sn && product?.model && downloadFolder != "s3path" &&
								<button onClick={() => {
									rct600Download(product.sn.toUpperCase());
									}} className="btn btn-outline-info btn-sm mt-0 me-1">
									{'Backup File Download'}
								</button>
							}
							{(!product?.orisn && product.snhistories?.length > 0 && !editable) && <select
								onChange={(x) => getOldInfo(x)}
								className="form-control form-control-sm float-start me-1" style={{ width: 120 }}>
								<option value="">SN History</option>
								{product.snhistories.map(x => <option value={x.sn}>{x.sn}</option>)}
							</select>}
							{product.orisn && <button className="btn btn-primary btn-sm mt-0" onClick={() => goRealSn()}>Now SN : {product.orisn}</button>}
							{!product.orisn && <>
								{
									(user.adminType == 'S' && user.companyId != 'RAY02091') && <Link to={"/Admin/AdminProductInfo/" + product.sn + "/changesn"} className="btn btn-danger btn-sm mt-0 me-1" onClick={() => setTab('changesn')}>{t('product.button.changeSn')}</Link>
								}
								{
									((user.adminType == 'S' || user?.isTypeChange) && user.companyId != 'RAY02091') && <Link to={"/Admin/AdminProductInfo/" + product.sn + "/changetype"} className="btn btn-danger btn-sm mt-0 me-1" onClick={() => setTab('changetype')}>{t('common.button.changeType')}</Link>
								}
								<button onClick={() => createService()} className="btn btn-outline-primary btn-sm mt-0 me-1">{t('service.button.addNew')}</button>

							</>}
							{user.adminType == "S" && (user?.companyId == "RAY00001") && <button className="btn btn-primary btn-sm mt-0" onClick={() => productReportshow()}>Product History</button>}
							{!product.orisn && <Link to={!isstock ? "/Admin/AdminProductList" : "/Admin/AdminProductStockList"} className="btn btn-outline-default btn-sm mt-0 ms-1">{t('common.label.list')}</Link>}
						</div>
					</div>

					{!showReport &&
						<div id="appCapsule" className="extra-header-active full-height">
							<div className="section mt-1 mb-1">
								<ul className="nav nav-tabs style2 mt-1 mb-1">
									{newTabList.filter(filter).map(x => {
										if (x.code == "warranty" && product.orisn)
											return;
										return (
											<li className="nav-item" key={x.code}>
												{product.orisn && <a className={tab == x.code ? "nav-link active" : "nav-link"} onClick={() => setTab(x.code)} >{x.title}</a>}
												{!product.orisn && <Link to={"/Admin/AdminProductInfo/" + product.sn + "/" + x.code}
													className={tab == x.code ? "nav-link active" : "nav-link"}
													onClick={() => setTab(x.code)}>{x.title}</Link>}
											</li>
										)
									})}
								</ul>
							</div>
							{(tab == "info" && product.sn) && <ProductInfoSummary productInfo={product} editable={editable} codes={codes} cancelcallback={() => setEditable(false)} />}
							{tab == "acquisition" && product.sn && <ProductInfoACQ product={product} />}
							{tab == "error" && product.sn && <ProductInfoError product={product} />}
							{tab == "qc" && product.sn && <ProductInfoQC product={product} />}
							{tab == "alignment" && product.sn && <ProductInfoAlignment product={product} />}
							{tab == "dia" && product.sn && <ProductInfoAutoDiagnosis product={product} />}
							{(!product.orisn && tab == "warranty") && product.sn && <ProductInfoWarranty product={product} />}
							{tab == "del" && product.sn && <ProductDelete product={product} />}
							{tab == "changesn" && product.sn && <ProductChangeSN product={product} />}
							{tab == "service" && product.sn && <ServiceAdminList warranties={product.waranties} sn={product.sn} />}
							{tab == "updatesite" && product.sn && <AdminProductUpdateSite product={product} />}
							{tab == "extra" && product.sn && <ProductInfoExtra productInfo={product} editable={editable} />}
							{tab == "changetype" && product.sn && <ProductChangeType product={product} />}

						</div>
					}
					{(showReport && product.sn) &&
						<ProductHistoryReport showModal={showReport} cancelcallback={() => setShowReport(false)} productInfo={product}></ProductHistoryReport>
					}

					<Modal show={showModal} fullscreen={"false"} onHide={() => setShowModal(false)}>
						<Modal.Header>
							<Modal.Title>{isKeyFileDownload ? t('license.button.keyFileDownload') : isRenewalLicense ? t('license.modal.ctLicenseRenewal') : t('license.modal.ctKeyIssuance')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className='p-1'>
								{isKeyFileDownload ? (
									<>
										* 5D Installer <b>Offline Mode</b> {t('license.modal.offlineModeAvailable')}<br />
										* {t('license.modal.copyKeyFilePrefix')} <b>licensekeyfiles</b> {t('license.modal.copyKeyFileSuffix')}
									</>
								) : (
									<>
										* 5D Installer <b>Offline Mode</b> {t('license.modal.offlineModeAvailable')}<br />
										{isRenewalLicense ? <>* {t('license.modal.licenseRenew')}</> : <>* {t('license.modal.licenseKeyIssue')}</>}<br />
										* {t('license.modal.copyKeyFilePrefix')} <b>licensekeyfiles</b> {t('license.modal.copyKeyFileSuffix')}
									</>
								)}
							</div>
						</Modal.Body>
						<Modal.Footer>
							<button className="btn btn-block btn-primary mb-0 mt-0" onClick={() => isKeyFileDownload ? getKeyFileDownload() : createCTLicense()} disabled={modalLoading}>
								{modalLoading &&
									<Loader
										type='TailSpin'
										color='#fff'
										width={20}
										height={20}
										visible={true}
										style={{ display: 'inline-block', marginRight: '10px' }} />
								}
								{!modalLoading && (isKeyFileDownload ? t('common.button.download') : t('common.button.create'))}</button>
							<button className="btn btn-block btn-dark" onClick={() => setShowModal(false)}>{t('common.button.close')}</button>
						</Modal.Footer>
					</Modal>
				</>
			}
			{isLoading && <div className="" style={{ marginTop : 120 }}>
				<Loading />
			</div>}
		</>
	);
};

const mapState = (state) => {
	const product = state.ProductReducer.product;
	const orisninfo = state.ProductReducer.orisninfo;
	const errmessage = state.AlertReducer.simplemessage;
	const isstock = state.ProgramReducer.productlistisstock || false;
	const user = state.AuthReducer.user;
	const clist = state.RayCodeReducer.items;
	const raycodes = state.RayCodeReducer.items;
	const company = state.CompanyReducer.company;
	return { product, isstock, orisninfo, errmessage, user, clist, raycodes, company };
};

const mapDispatch = (dispatch) => ({
	GetProduct: (sn) => dispatch(ProductAction.GetProduct(sn, { quietNotFound: true })),
	GetProductOld: (sn, snobj) => dispatch(ProductAction.GetProductOld(sn, snobj)),
	GetCompanyInfo: (companyId) => dispatch(CompanyAction.GetCompanyInfo(companyId)),
});

export default connect(mapState, mapDispatch)(AdminProductInfo);
